import ChangePass from "./ChangePass";

export default ChangePass;
